/*=========================================================================================
  File Name: moduleActivityMutations.js
  Description: Activity Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Felix MAsa
  
==========================================================================================*/

export default {
	ADD_LAYER_ITEM(state, layer) {
		state.layers.unshift(layer);
	},
	CURRENT_LAYER_ITEM(state, layer) {
		state.currentLayer = layer;
	},
	SET_LAYERS(state, layers) {
		state.layers = layers;
	},
	UPDATE_LAYER(state, layer) {
		const layerIndex = state.layers.findIndex((l) => l.id === layer.id);
		Object.assign(state.layers[layerIndex], layer);
	},
	REMOVE_LAYER_ITEM(state, layerId) {
		const ItemIndex = state.layers.findIndex((l) => l.id === layerId);
		state.layers.splice(ItemIndex, 1);
	},
	ADD_ZONE_ITEMS(state, data) {
		state.zones.unshift(data);
	},
	CLEAN_ZONE_ITEMS(state) {
		state.zones = [];
	},
	ADD_ZONE_CHILDRES_ITEMS(state, {rows}) {
		/* const layerIndex = state.zones.findIndex((l) => l.id === layer.id)
    Object.assign(state.zones[layerIndex], layer) */
		state.zones[0].children = rows.map((r) => {
			return {
				id: r.cartodb_id,
				label: r.name,
				value: r,
			};
		});
	},
};
